// extracted by mini-css-extract-plugin
export var buttonsWrapp = "SplitSection-module--buttonsWrapp--7a1b4";
export var container = "SplitSection-module--container--c9b50";
export var contentWrap = "SplitSection-module--contentWrap--02ef5";
export var greyBackground = "SplitSection-module--greyBackground--92578";
export var imageContainer = "SplitSection-module--imageContainer--3d7bb";
export var imageOverlay = "SplitSection-module--imageOverlay--9e289";
export var imageRight = "SplitSection-module--imageRight--1bb6e";
export var imageWrap = "SplitSection-module--imageWrap--4c1f0";
export var splitSection = "SplitSection-module--splitSection--44fb2";
export var subHeading = "SplitSection-module--subHeading--8f304";
export var subImageWrapp = "SplitSection-module--subImageWrapp--e26c0";
export var subTitle = "SplitSection-module--subTitle--3cbeb";
export var text = "SplitSection-module--text--174cc";
export var title = "SplitSection-module--title--7930b";
export var withSubImage = "SplitSection-module--withSubImage--a4aab";